
import React from "react";

import "../styles/ElementalStyles.css";
import { usePageInitialization } from "../hooks/usePageInitialization";

// Import the individual section components
import Header from "../components/sections/Header";
import SplashScreen from "../components/sections/SplashScreen";
import Intro from "../components/sections/Intro";
import Clients from "../components/sections/Clients";
import About from "../components/sections/About";
import Approach from "../components/sections/Approach";
import Footer from "../components/sections/Footer";
import Subvencio from "../components/sections/Subvencio";
import HeadMeta from "../components/sections/HeadMeta";

const HomePage = () => {
  // Use our new centralized initialization hook
  usePageInitialization("Elemental Value", {
    handleSplash: true,
    initSwiper: false // We're using our new carousel now
  });

  return (
    <>
      <HeadMeta
        title="Elemental Value (versión anterior)"
        description="Versión anterior de la home de Elemental Value."
        canonicalPath="/home-antigua"
        noindex
      />
      <Header />
      <SplashScreen />
      <Intro />
      <Clients />
      <About />
      <Approach />
      <Footer />
      <Subvencio />
    </>
  );
};

export default HomePage;
